import { EQUAL, LESS_THEN_OR_EQUAL, MORE_THEN_OR_EQUAL } from '../../utils';
/** Detect Internet Explorer Browser and wanted version */
export default function isIEVersion(operator, version) {
	return function (ua) {
		var versions = [];
		versions[8] = function () {
			return /MSIE 8\.\d/i.test(ua) || /MSIE 7\.0; Windows NT 6\.0/i.test(ua);
		};
		versions[9] = function () {
			return /MSIE 9\.\d/i.test(ua);
		};
		versions[10] = function () {
			return /MSIE 10\.\d/i.test(ua);
		};
		versions[11] = function () {
			return /Trident.*rv[ :]*11\./.test(ua);
		};
		switch (operator) {
			case EQUAL: {
				var fn = versions[version];
				return typeof fn === 'function' && fn();
			}
			case MORE_THEN_OR_EQUAL:
				return versions.slice(version).some(function (fn) {
					return fn();
				});
			case LESS_THEN_OR_EQUAL:
				return versions.slice(0, version + 1).some(function (fn) {
					return fn();
				});
			default:
				return false;
		}
	};
}
